// BatchUtilitiesDialog.tsx — Batch copy / duplicate panels by qty

import { useState } from 'react';
import DialogBase from './DialogBase';
import { useShallowStore } from '../store/useStore';

export default function BatchUtilitiesDialog() {
  const { ui, project, duplicatePanel } = useShallowStore(s => ({
    ui:             s.ui,
    project:        s.project,
    duplicatePanel: s.duplicatePanel,
  }));

  const panel = project?.panels.find(p => p.id === ui.activePanelId);
  const [copies, setCopies] = useState(1);

  if (!panel) return null;

  return (
    <DialogBase
      title="Batch Utilities"
      onOk={() => {
        for (let i = 0; i < copies; i++) duplicatePanel(panel.id);
      }}
      okLabel={`Duplicate ×${copies}`}
    >
      <p className="dialog-info">
        Active panel: <strong>{panel.mpvar.panelMark}</strong>
      </p>
      <div className="dialog-row">
        <label className="dialog-label">Duplicate count</label>
        <input
          className="dialog-input sm"
          type="number"
          value={copies}
          min={1}
          max={50}
          step={1}
          onChange={e => setCopies(Math.max(1, parseInt(e.target.value)))}
        />
      </div>
    </DialogBase>
  );
}
